/* FLICK-S: nur die Bewegung fuer den Hintergrund (volle Dokument-Hoehe +
   Scroll-Parallax/-Rotation/-Drift + Symbol-Entzerrung). Bewusst getrennt von
   flx-scroll-reveal.js, das zusaetzlich Sections beim Scrollen einblendet -
   hier auf der Passwort-Seite soll NUR der Hintergrund etwas tun, sonst nichts.
   2026-08-08 (Philip): um Squash-Entzerrung (--flx-squash) + Symbol-Drift
   (data-flx-drift-seed) erweitert, seit die Passwortseite auf symbols:true
   umgestellt wurde (identische Hintergrund-Animation wie auf der Homepage,
   siehe layout/password.liquid + assets/flx-scroll-reveal.js fuer das
   Original auf der normalen Seite). */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Mobile-/Seitenverhaeltnis-Entzerrung: die Hintergrund-SVG wird per
  // preserveAspectRatio="none" auf die Dokumentflaeche gestreckt -> runde
  // Symbole wuerden laenglich. --flx-squash = (Breiten-Skalierung /
  // Hoehen-Skalierung); die CSS-Regel .flx-sym-squash dreht das wieder heraus.
  function updateSquash() {
    document.querySelectorAll(".flx-bg-paths").forEach(function (layer) {
      var svg = layer.querySelector("svg");
      if (!svg || !svg.viewBox || !svg.viewBox.baseVal) return;
      var vb = svg.viewBox.baseVal;
      var w = layer.clientWidth;
      var h = layer.clientHeight;
      if (!w || !h || !vb.width || !vb.height) return;
      var scaleX = w / vb.width;
      var scaleY = h / vb.height;
      if (!scaleY) return;
      layer.style.setProperty("--flx-squash", scaleX / scaleY);
    });
  }

  function initBgHeight() {
    var el = document.querySelector(".flx-bg-paths--fixed");
    if (!el) { updateSquash(); return; }
    var lastHeight = 0;
    var scheduled = false;
    function measure() {
      scheduled = false;
      var height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      if (height !== lastHeight) {
        lastHeight = height;
        el.style.bottom = "auto";
        el.style.height = height + "px";
      }
      // Nach jeder Hoehenmessung die Entzerrung neu berechnen (Hoehe fliesst ein).
      updateSquash();
    }
    window.addEventListener("resize", updateSquash);
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(measure);
    }
    measure();
    window.addEventListener("load", schedule);
    window.addEventListener("resize", schedule);
    if ("ResizeObserver" in window) {
      new ResizeObserver(schedule).observe(document.body);
    }
    if ("MutationObserver" in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    setTimeout(schedule, 800);
    setTimeout(schedule, 2500);
  }

  function initScrollSpin() {
    var spinners = document.querySelectorAll("[data-flx-scroll-spin]");
    var parallax = document.querySelectorAll("[data-flx-scroll-parallax]");
    // Begrenzte Wisch-Bewegung fuer die Hintergrund-Symbole (sinusfoermig um
    // scrollY, schwingt immer zwischen +-Amplitude - kann nie aus dem Bild
    // wandern). Gleiche Logik wie assets/flx-scroll-reveal.js auf der
    // normalen Seite.
    var drifters = document.querySelectorAll("[data-flx-drift-seed]");
    if ((!spinners.length && !parallax.length && !drifters.length) || prefersReducedMotion) return;

    var DRIFT_AMP_X = 16;
    var DRIFT_AMP_Y = 11;

    var ticking = false;
    function update() {
      var scrollY = window.scrollY;
      var deg = scrollY * 0.12;
      spinners.forEach(function (el) {
        var dir = parseFloat(el.getAttribute("data-flx-scroll-spin")) || 1;
        el.style.transform = "rotate(" + (deg * dir) + "deg)";
      });
      parallax.forEach(function (el) {
        var coeff = parseFloat(el.getAttribute("data-flx-scroll-parallax")) || 0;
        el.style.transform = "translateY(" + (scrollY * coeff) + "px)";
      });
      drifters.forEach(function (el) {
        var seed = parseFloat(el.getAttribute("data-flx-drift-seed")) || 0;
        var dx = Math.sin(scrollY / 340 + seed * 1.7) * DRIFT_AMP_X;
        var dy = Math.cos(scrollY / 280 + seed * 1.1) * DRIFT_AMP_Y;
        el.style.transform = "translate(" + dx.toFixed(1) + "px," + dy.toFixed(1) + "px)";
      });
      ticking = false;
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBgHeight);
    document.addEventListener("DOMContentLoaded", initScrollSpin);
  } else {
    initBgHeight();
    initScrollSpin();
  }
})();
